<template>
	<div>
		<draggable
			tag="ul"
			:list="list"
			class="mb-2 list-group"
			handle=".handle">
			<li
				class="list-group-item handle"
				v-for="(element, idx) in list"
				:key="element.id">
				<i class="fa fa-times close" @click="removeAt(idx)"></i>
				<vue-tags-input
					:placeholder="'ajouter un élément'"
					:autocomplete-min-length="0"
					:autocomplete-items="filteredItems(idx)"
					style="max-width: 100%; margin-right: 30px"
					obj_words
					v-model="element.word"
					:tags="element.words"
					:allow-edit-tags="true"
					@tags-changed="(newTags) => (element.words = newTags)" />
			</li>
		</draggable>

		<b-button @click="addList">Ajouter ligne</b-button>&nbsp;
	</div>
</template>

<script>

	const clone = require("clone");
	const _ = require("underscore");

	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import VueTagsInput from "@johmun/vue-tags-input";

	export default {
		name: "list_param",
		components: {
			VueTagsInput,
			draggable,
		},
		props: {
			columns_data: {
				default: () => []
			},
			is_data_columns: {
				default: false
			}
		},
		data() {
			return {
				columns_data_text: [],
				ready: false,
				name: "",
				list: [],
				column: "",
				test_variant: "",
				test_variant_result: [],
				variant_parameters: [],
				test_regex: "",
				text_list: "",
				variant_show: false,
				filter_show: false,
				version: "",
				db: false,
				lists_db: {},
				lists_name_db: [],
				exist_db: false,
			};
		},
		watch: {
			columns_data: {
				immediate: true,
				async handler() {
					if (this.is_data_columns)
					{
						this.columns_data_text = [];
						for (var i = 0; i < this.columns_data.length; i++)
						{
							this.columns_data_text.push({text: this.columns_data[i]});
						}
					}
				}
			}
		},
		methods: {
            filteredItems(idx) {
                return this.columns_data_text.filter(i => {
                    return i.text.toLowerCase().indexOf(this.list[idx].word.toLowerCase()) !== -1;
                });
            },
			removeAt(idx) {
				this.list.splice(idx, 1);
			},
			addList: function () {
				this.list.push({ id: uniqueId(""), words: [], word: "" });
			},
		 	get_data()
			{
				return this.save();
			},
			async load(data) {
				this.list = []

				console.log("load")
				console.log(data)

				for (var i = 0; i < data.length; i++)
				{
					var words = [];

					for (var j = 0; j < data[i].length; j++)
					{
						words.push({text: data[i][j]})
					}

					this.list.push({ id: uniqueId(""), words, word: "" });
				}
			},
			save() {

				console.log("save list params")
				console.log(this.list)
				var list = clone(this.list);

				for (var i = 0; i < list.length; i++)
				{
					for (var j = 0; j < list[i].words.length; j++)
					{
						console.log("text")
						console.log(list[i].words[j].text)
						list[i].words[j] = list[i].words[j].text;
					}
					list[i] = list[i].words;
				}

				console.log(list)

				return list;
			},
		},
		mounted: async function () {
			var self = this;
		},
	};
</script>
&&
<style scoped></style>
